import Image, { ImageProps } from "next/image";
import { useAppSelector } from "../../../services/hooks/useReduxHooks";

type PImageProps = Omit<ImageProps, "src"> & {
  src?: ImageProps["src"] | null;
  /**
   * Fall back to the restaurant logo when src is empty (the category-card
   * convention). Set false where a logo would be wrong (banners, org
   * logos, gallery slides) — the component then renders nothing instead.
   */
  logoFallback?: boolean;
};

/**
 * next/image for data-driven sources (img_url, offer graphics, logos).
 * Resolves src → restaurant logo → nothing, so an empty URL never
 * reaches the DOM: <img src=""> makes the browser re-request the page
 * itself and renders a broken frame.
 */
export const PImage = ({ src, logoFallback = true, ...rest }: PImageProps) => {
  // config?. tolerates the partial mock states unit tests pass to
  // components that don't know they render a PImage.
  const restaurantLogoUrl = useAppSelector(
    (state) => state.config?.restaurantInfo?.logoUrl
  );

  const resolvedSrc = src || (logoFallback ? restaurantLogoUrl : "") || "";
  if (!resolvedSrc) {
    return null;
  }

  return <Image src={resolvedSrc} {...rest} />;
};
